import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { digitizationRoutes } from './digitization.routing'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '@shared/shared.module'
import { DigitizationComponent } from './digitization.component'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'
import { DigitizationMapModule } from '@components/digitization-map/digitization-map.module'

@NgModule({
  declarations: [DigitizationComponent],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(digitizationRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
    DigitizationMapModule,
    ContentEditableModule,
  ],
  exports: [],
})
export class DigitizationModule {}
